import axios from "axios";
import { constants } from "../constants/variables";

export const openSnackAlert = (messageee, typeee) => {
  constants.snackAlert.openSnack(messageee, typeee);
};

export const uploadMediaService = async (imagee) => {
  const form = new FormData();
  form.append("file", imagee);
  form.append("upload_preset", "znblmci9");
  form.append("cloud_name", "dhiurzrrx");

  return new Promise((resolve, reject) => {
    axios
      .post(`https://api.cloudinary.com/v1_1/dhiurzrrx/image/upload`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          resolve(response.data.secure_url);
        } else {
          reject("Image uploading failed.");
        }
      })
      .catch(() => {
        reject("Image uploading failed.");
      });
  });
};

export const uploadExcelService = async (file) => {
  const form = new FormData();
  form.append("file", file);
  form.append("upload_preset", "znblmci9");
  form.append("cloud_name", "dhiurzrrx");
  form.append("resource_type", "raw");

  return new Promise((resolve, reject) => {
    axios
      .post(`https://api.cloudinary.com/v1_1/dhiurzrrx/raw/upload`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          resolve(response.data.secure_url);
        } else {
          reject("Excel file uploading failed.");
        }
      })
      .catch((error) => {
        console.error("Upload error:", error);
        reject("Excel file uploading failed.");
      });
  });
};